import { IS_LOADING_CATEGORY_HOME } from "../../ActionType/actionTypes";

const initialState = {
    isLoadingCategoryHome: true
}

const isLoadingCategoryReducer = (state = initialState, action) => {
    if (action.type === IS_LOADING_CATEGORY_HOME) {
        return { ...state, isLoadingCategoryHome: action.payload.isLoadingCategoryHome }
    } else {
        return state
    }
}

export default isLoadingCategoryReducer